import { BaseError } from '../../_base/lang/BaseError';

export class NameAndLabelCannotBeEmptyError extends BaseError {}
